import LoginPassword from './LoginPassword';

export default LoginPassword;
